import type { DesignPreferenceItemFormatted } from "../types/designPreferences";

type DesignPreferenceGroup = {
  header: DesignPreferenceItemFormatted;
  sections: {
    subHeader?: DesignPreferenceItemFormatted;
    fields: DesignPreferenceItemFormatted[];
  }[];
};

const groupDesignPreferences = (
  items: DesignPreferenceItemFormatted[]
): DesignPreferenceGroup[] => {
  if (!items || items.length === 0) {
    return [];
  }

  const groups: DesignPreferenceGroup[] = [];
  let currentGroup: DesignPreferenceGroup | null = null;
  let currentSection: {
    subHeader?: DesignPreferenceItemFormatted;
    fields: DesignPreferenceItemFormatted[];
  } | null = null;

  for (const item of items) {
    if (item.respDataType === "Header") {
      if (currentGroup) {
        if (currentSection) {
          currentGroup.sections.push(currentSection);
        }
        groups.push(currentGroup);
      }

      currentGroup = {
        header: item,
        sections: [],
      };
      currentSection = {
        fields: [],
      };
    } else if (item.respDataType === "SubHeader") {
      if (
        currentSection &&
        (currentSection.fields.length > 0 || currentSection.subHeader)
      ) {
        if (currentGroup) {
          currentGroup.sections.push(currentSection);
        }
      }

      currentSection = {
        subHeader: item,
        fields: [],
      };
    } else {
      if (!currentSection) {
        currentSection = {
          fields: [],
        };
      }
      currentSection.fields.push(item);
    }
  }

  if (currentGroup) {
    if (currentSection) {
      currentGroup.sections.push(currentSection);
    }
    groups.push(currentGroup);
  }

  return groups;
};

const getDisplayValue = (item: DesignPreferenceItemFormatted): string => {
  return getInitialValue(item).trim() || "-";
};

const getInitialValue = (item: DesignPreferenceItemFormatted): string => {
  if (item.respDataType === "Picklist") {
    return item.responseList![0]!.value;
  } else if (item.response === "opptyList[0].HOA__c") {
    return "No";
  } else if (item.respDataType === "MultiSelectPicklist") {
    return item.response?.split(";")?.join(", ") ?? "";
  }
  return item.response ?? "";
};

const getFieldKey = (
  item: DesignPreferenceItemFormatted,
  index: number
): string => {
  return `${index}-${item.opptyId}`;
};

export {
  groupDesignPreferences,
  getDisplayValue,
  getInitialValue,
  getFieldKey,
};
